<rt-activity-subscriptions-table
  [types]="types"
  [title]="'app.subscriptions.followed_requisitions' | translate"
>
  <rt-activity-subscriptions-table-row
    icon="visibility"
    [title]="'app.subscriptions.events_group.status_changed' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="[
      'requisitionApprovalRequestCanceled',
      'requisitionArchived',
      'requisitionApprovalRequested',
      'requisitionRetrieved',
      'requisitionStatusChange',
    ]"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    icon="timer-sand"
    [title]="'app.subscriptions.events_group.requisition_reviewed' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['requisitionApproverDecisionApproved', 'requisitionApproverDecisionRejected']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    icon="timer-sand"
    [title]="'app.subscriptions.events_group.requisition_sent' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="[
      'requisitionApproverDecisionPending',
      'requisitionApproverDecisionCanceled',
      'requisitionApproverDecisionReminder',
    ]"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
  <rt-activity-subscriptions-table-row
    icon="attach-file"
    [title]="'app.subscriptions.events_group.requisition_file_uploaded' | translate"
    [activitySubscriptions]="activitySubscriptions"
    [types]="types"
    [eventsGroup]="['requisitionAttachmentUpload', 'requisitionAttachmentRemove']"
    (changeEvents)="changeEvents.emit($event)"
  >
  </rt-activity-subscriptions-table-row>
</rt-activity-subscriptions-table>
